import { Card, CardBody, Col} from "reactstrap";
import {  BorderBottomText1, BorderBottomText2, BorderBottomTextEm, BottomBorder } from "../../../../Constant";
import { BORDER_BOTTOM } from "../../../../Data/Bonus Ui/CreativeCard";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { P } from "../../../../AbstractElements";

const BorderBottom = () => {
  return (
    <Col sm="12" md="6">
    <Card>
      <CommonCreativeCardHeader headerClass="border-b-info border-3" title={BottomBorder} span={BORDER_BOTTOM} />
      <CardBody>
      <P className="mb-0">{BorderBottomText1}<em className="txt-danger">{BorderBottomTextEm}</em>{BorderBottomText2}</P>
      </CardBody>
    </Card> 
  </Col>
  )
}

export default BorderBottom